<template>
  <div>
    <div class="c-fieldset">
      <p class="c-fieldset__header">
        <span class="c-fieldset__title">カード番号</span>
      </p>
      <div class="c-fieldset__content c-alertPos l-w-190">
        <div class="c-input" ref="cardNumber"></div>
        <Alert v-if="error.cardNumber">
          {{ error.cardNumber }}
        </Alert>
      </div>
    </div>
    <div class="c-fieldset">
      <p class="c-fieldset__header">
        <span class="c-fieldset__title">有効期限</span>
      </p>
      <div class="c-fieldset__content l-row l-no-gutters l-align-items-center">
        <div class="c-alertPos">
          <div class="c-input l-w-85" ref="cardExpiry"></div>
          <Alert v-if="error.cardExpiry">
            {{ error.cardExpiry }}
          </Alert>
        </div>
        <div class="l-ml-2">
          <p>月 / 年</p>
        </div>
      </div>
    </div>
    <div class="c-fieldset">
      <p class="c-fieldset__header">
        <span class="c-fieldset__title">セキュリティコード</span>
      </p>
      <div class="c-fieldset__content l-row l-no-gutters l-align-items-center">
        <div class="c-alertPos">
          <div class="c-input l-w-85" ref="cardCvc"></div>
          <Alert v-if="error.cardCvc">
            {{ error.cardCvc }}
          </Alert>
        </div>
        <div class="l-ml-2">
          <p>3桁または4桁の暗証番号</p>
        </div>
      </div>
    </div>

    <div class="c-text--center l-mt-6">
      <Button
        variant="main"
        size="w260"
        fsize="f16"
        icon="arrow_r"
        :class="{ 'is-loading': isProcessing }"
        :disabled="isProcessing"
        @click="submit"
      >
        {{ isEdit ? '変更する' : '登録する' }}
      </Button>
    </div>
    <Alert v-if="errorResponse" class="l-mt-3">
      {{ errorResponse }}
    </Alert>
  </div>
</template>

<script>
import { STRIPE_CONFIG } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import apiOrgs from '@/api/orgs';
import apiUsers from '@/api/users';

export default {
  props: {
    params: {
      type: Object,
      required: false
    },
    isEdit: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Alert,
    Button
  },

  data() {
    return {
      error: {
        cardNumber: '',
        cardExpiry: '',
        cardCvc: ''
      },
      errorResponse: '',
      stripe: {
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        client: '',
        elements: ''
      },
      isProcessing: false
    };
  },

  computed: {
    apiKey() {
      if (this.isTester) {
        return STRIPE_CONFIG.apiKey.test;
      }
      return STRIPE_CONFIG.apiKey.default;
    },
    isTester() {
      return this.$store.state.user.status.isTester;
    }
  },

  created() {
    this.stripe.client = Stripe(this.apiKey);
    this.stripe.elements = this.stripe.client.elements();
    this.$nextTick(() => {
      this.initElement('cardNumber');
      this.initElement('cardExpiry');
      this.initElement('cardCvc');
    });
  },

  methods: {
    initElement(name) {
      this.stripe[name] = this.stripe.elements.create(name, {
        style: STRIPE_CONFIG.style
      });
      this.stripe[name].mount(this.$refs[name]);
      this.stripe[name].addEventListener('change', e => {
        this.changeValue(e, name);
      });
    },

    clearElement(name) {
      this.stripe[name].clear();
    },

    changeValue(e, name) {
      if (e.error) {
        this.error[name] = e.error.message.replace(/。$/, '');
      } else {
        this.error[name] = '';
      }
      this.errorResponse = '';
    },

    postSubscriptions(token) {
      let params = {
        cardToken: token,
        planId: this.params.planId
      };
      return apiOrgs.subscriptions.post(params, this.auth.idToken);
    },

    putCard(token) {
      let params = {
        cardToken: token
      };
      return apiUsers.me.creditCard.put(params, this.auth.idToken);
    },

    submit() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      this.stripe.client.createToken(this.stripe.cardNumber).then(result => {
        if (result.error) {
          this.errorResponse = result.error.message;
          this.isProcessing = false;
          return;
        }

        // 初回登録とカード情報変更で叩くメソッドを変える
        let method = this.isEdit ? 'putCard' : 'postSubscriptions';

        this[method](result.token.id)
          .then(response => {
            this.errorResponse = '';
            this.clearElement('cardNumber');
            this.clearElement('cardExpiry');
            this.clearElement('cardCvc');
            this.$emit('submit');
          })
          .catch(error => {
            if (error.response) {
              this.errorResponse = error.response.data.errors[0].userMessage;
            }
          })
          .finally(() => {
            this.isProcessing = false;
          });
      });
    }
  }
};
</script>
